import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
//DS
import SelectBase from '../../atomicos/SelectBase';
import useApiRest from '../../../hooks/useApiRest';
import {SP_CARGANDO, SP_ERROR, SP_NO_DATA} from '../../../constants/componentValues';

const SelectFetch = (props) => {
   const {genElemento, endpoint, fetchOptions, recuperarOnFocus, ...other} = props;
   const [fetch, {loading, error}] = useApiRest(endpoint, {callbackProcesarData}, fetchOptions);
   function callbackProcesarData(data) {
      generarOptions(data);
   }
   useEffect(() => {
      fetch();
   }, []);
   const [options, setOptions] = useState([]);
   async function generarOptions(data) {
      let optionsD = await Promise.all(
         data.map(async (registro) => {
            return await genElemento(registro);
         })
      );
      setOptions(optionsD);
   }

   function onFocus() {
      if (recuperarOnFocus) {
         fetch();
      }
   }

   if (loading) {
      let optionsCargando = [SP_CARGANDO];
      return <SelectBase options={optionsCargando} {...other} />;
   }

   if (error) {
      let optionsError = [SP_ERROR];
      return <SelectBase options={optionsError} {...other} />;
   }

   if (options.length > 0) {
      return <SelectBase options={options} {...other} onFocus={onFocus} />;
   }

   let optionsVacio = [SP_NO_DATA];
   return <SelectBase options={optionsVacio} {...other} onFocus={onFocus} />;
};

const genDefault = (registro) => {
   return registro[Object.keys(registro)[0]];
};

/**
 * Extension de SelectBase para manejo rapido del componente y agregada funcionalidad para consultar a api Rest.
 */
const SelectRest = (props) => {
   const {
      //Propiedades del componente
      data,
      genId,
      genLabel,
      endpoint,
      fetchOptions,
      //Propiedades del select
      ...other
   } = props;

   const [options, setOptions] = useState([]);
   useEffect(() => {
      if (data && data.length > 0) {
         genOptions();
      }
   }, [data]);

   async function genOptions() {
      const newOptions = await Promise.all(
         data.map(async (registro) => {
            return await genElemento(registro);
         })
      );
      setOptions(newOptions);
   }

   const genElemento = async (registro) => {
      const value = await genId(registro);
      const label = await genLabel(registro);
      return {value, label};
   };

   if (data) {
      return <SelectBase options={options} {...other} />;
   }

   if (endpoint) {
      return (
         <SelectFetch
            genElemento={genElemento}
            endpoint={endpoint}
            fetchOptions={fetchOptions}
            {...other}
         />
      );
   }
   return null;
};

SelectRest.propTypes = {
   /**
    * Informacion origen de las opciones a mostras en el componente. Si es proporcionada no se tomaran en cuenta las propiedades `entidad` ni `campos`.
    */
   data: PropTypes.arrayOf(PropTypes.object),
   /**
    * Funcion para generar la propiedad `value` del estado del componente componente. Debe aceptar un parametro de tipo objeto con la estructura de los objetos de la propiedad `data` o de los objetos recuperados de la consulta. Debe retornar un `string`.
    */
   genId: PropTypes.func,
   /**
    * Funcion para generar la propiedad `label` del estado del componente componente qu es el valor que se muestra en el deplegable. Debe aceptar un parametro de tipo objeto con la estructura de los objetos de la propiedad `data` o de los objetos recuperados de la consulta. Debe retornar un `string`.
    */
   genLabel: PropTypes.func.isRequired,
   /**
    * endpoint del servidor GraphQL que se desea utilizar.
    */
   endpoint: PropTypes.string,
   /**
    * Opciones adicionales de la peticion, para mas detalle https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
    */
   fetchOptions: PropTypes.object,
   /**
    * Si es true, recuperara la información del api cuando el componente tenga el focus
    */
   recuperarOnFocus: PropTypes.bool
};

SelectRest.defaultProps = {
   genId: genDefault,
   genLabel: genDefault
};

export default SelectRest;
